var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wasteproduction-edit',{attrs:{"organization-waste":_vm.organizationWaste}})
}
var staticRenderFns = []

export { render, staticRenderFns }